import AccountBoxIcon from '@mui/icons-material/AccountBox'
import HomeIcon from '@mui/icons-material/Home'
import { SxProps } from '@mui/material'
import BottomNavigation from '@mui/material/BottomNavigation'
import BottomNavigationAction from '@mui/material/BottomNavigationAction'
import Paper from '@mui/material/Paper'
import { routes, navigate } from '@redwoodjs/router'
import { useMemo } from 'react'
import CommunityIcon from 'src/components/icons/CommunityIcon'
import useProfile from 'src/hooks/useProfile'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

const BottomNavigationBar = ({ sx = {} }: { sx?: SxProps }) => {
  const { data: profile } = useProfile()

  const actions = useMemo(
    () => [
      {
        key: 'HOME',
        Icon: HomeIcon,
        label: 'Home',
        handler: () => navigate(routes.home()),
      },
      {
        key: 'FANS',
        Icon: CommunityIcon,
        label: 'Account',
        handler: () => navigate(routes.fanDashboard()),
      },
      {
        key: 'SETTINGS',
        Icon: AccountBoxIcon,
        label: 'Analytics',
        handler: () => navigate(routes.accountSettings()),
      },
      // {
      //   key: 'ANALYTICS',
      //   Icon: AnalyticsOutlinedIcon,
      //   label: 'Analytics',
      //   handler: () =>
      //     navigate(
      //       routes.artistAnalyticsSummary({ slug: profile?.artist?.slug })
      //     ),
      // },
    ],
    [profile]
  )
  const theme = useTheme()
  const isMDUp = useMediaQuery(theme.breakpoints.up('md'))

  return (
    <Paper
      component="footer"
      sx={{
        gridArea: 'footer',
        position: 'relative',
        height: '56px',
        zIndex: 2,
        display: isMDUp ? 'none' : 'inherit',
        ...sx,
      }}
      elevation={3}
    >
      <BottomNavigation
        sx={{
          bgcolor: 'primary.main',
          width: '100%',
        }}
        onChange={(_, key: string) => {
          actions?.find((action) => action.key === key)?.handler?.()
        }}
      >
        {actions.map(({ key, Icon, label }) => (
          <BottomNavigationAction
            key={key}
            label={label}
            value={key}
            icon={<Icon />}
            sx={{
              color: '#000',
            }}
          />
        ))}
      </BottomNavigation>
    </Paper>
  )
}

export default BottomNavigationBar
